import React from 'react';
import { featureFlag } from 'FeatureFlags/utils/hasFeatureEnabled';
import { Feature } from 'FeatureFlags/types';
import { totalGEACablelinkCostInstall } from 'Quotes/QuoteBuilder/utils/costsUtilities';
import { ProductType } from 'Quotes/types/productTypes';
import CostDisplay from './CostDisplay';
import { IAEndLocation, IPriceData, IQuote } from 'Quotes/types/store';
import { IMDIACosts } from 'Quotes/QuoteBuilder/components/Price/components/TillReceiptInternal/TillReceiptInternal';
import { getAdditionalPrice, selectQuote } from 'Quotes/selectors';
import { IAppState } from 'reducers';
import { connect } from 'react-redux';
import { TIER_NAMES } from '../DDOSProtection';

interface CostsInternalInstallProps {
  quote?: IQuote;
  selectedPrice: IPriceData;
  isFTTXQuote: boolean;
  productType: ProductType | null | undefined;
  isManagedDIA: IAEndLocation['is_managed_dia'];
  mdiaCosts?: IMDIACosts | undefined;
}

export const CostsInternalInstall: React.FC<CostsInternalInstallProps> = ({
  quote, 
  selectedPrice,
  productType,
  isFTTXQuote,
  isManagedDIA,
  mdiaCosts = { engineerInstallation: 0, rackMountKit: 0, router: 0 },
}) => {
  const supplierSetupCostAEnd = selectedPrice.a_end_setup_cost ?? 0;
  const supplierSetupCostBEnd = selectedPrice.b_end_setup_cost ?? 0;
  const bandwidthCostInstall = selectedPrice.bandwidth_cost?.install ?? 0;
  const geaCableLinkInstall = totalGEACablelinkCostInstall(selectedPrice);
  const portsCostSetup = selectedPrice.port_costs_setup ?? 0;
  const ddosProtectionCost = getAdditionalPrice(selectedPrice.additional_prices, `DDoS Protection - ${quote?.ddosProtection} Cost`)?.install;
  return (
    <>
      <CostDisplay label="A-End Supplier Costs" cost={supplierSetupCostAEnd} />

      <CostDisplay label={(productType === ProductType.DIA || productType === ProductType.P2CCT || productType === ProductType.NNI2CCT) ? "Cloud Connect Supplier Costs" : "B-End Supplier Costs"} cost={supplierSetupCostBEnd} />

      {portsCostSetup > 0 && <CostDisplay label="Port Costs" cost={portsCostSetup} />}

      {productType === ProductType.OpticalP2P && <CostDisplay label="Cross Connect Costs" cost={bandwidthCostInstall} />}

      {productType === ProductType.DIA && <CostDisplay label="Bandwidth Costs" cost={bandwidthCostInstall} />}

      {productType === ProductType.DIA && isManagedDIA && (
        <>
          {mdiaCosts.router > 0 && <CostDisplay label="Managed DIA router Costs" cost={mdiaCosts.router} />}
          {featureFlag.isEnabled(Feature.newMDIAUI) && mdiaCosts.engineerInstallation > 0 && (
            <CostDisplay label="Engineer installation Costs" cost={mdiaCosts.engineerInstallation} />
          )}
          {featureFlag.isEnabled(Feature.newMDIAUI) && mdiaCosts.rackMountKit > 0 && (
            <CostDisplay label="Rack mount kit Costs" cost={mdiaCosts.rackMountKit} />
          )}
        </>
      )}

      {isFTTXQuote && geaCableLinkInstall > 0 && <CostDisplay label="GEA Cablelink Costs" cost={geaCableLinkInstall} />}

      {quote?.ddosProtection && ddosProtectionCost !== 0 && ( 
        <CostDisplay label={`DDoS Protection (${TIER_NAMES[quote?.ddosProtection]})`} 
          cost={ddosProtectionCost ?? 0} />
      )}
    </>
  );
};

const mapStateToProps = (state: IAppState) => ({
  quote: selectQuote(state),
});

export default connect(mapStateToProps)(CostsInternalInstall);